import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './App.css'; // Assuming you have this CSS file for custom styles

function Modal({ onClose }) {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
    setShowModal(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 2000); // Display the modal after 2 seconds

    return () => clearTimeout(timer); // Clean up the timer
  }, []);

  const handleGallery= () => {
    handleClose(); // Close the modal when Donate button is clicked
  };

  return (
    <div>
      {showModal && (
        <div className="fixed inset-0 z-50 overflow-auto bg-gray-900 bg-opacity-50 flex justify-center items-center">
          <div className={`bg-red-700 rounded-lg p-4 w-80 md:w-96 lg:w-1/2 relative flex flex-col items-center modal-slide-down`}>
            <button
              className="absolute top-0 right-0 m-4 text-gray-700 hover:text-gray-900 text-3xl"
              onClick={handleClose}
            >
              &times;
            </button>

            <div className="flex flex-col items-center">
              <h2 className='mt-4 text-white text-3xl font-bold text-center font-heading3'>UPCOMING EVENT !!!</h2>
             <div className="text-black text-xl font-semibold px-4 text-center space-y-4">
  <p>
    <strong>Join us for a charity drive at Mji Wa Huruma / Nyumba ya wazee (The Elderly) on Sunday the 15th February 2026.</strong>
  </p>
  <p>
    <em>All types of donations are welcome.</em>
  </p>
</div>
            </div>

            <div className="py-4 flex justify-center">
              <Link to="/Events">
                <button className='text-white font-location px-8 bg-black rounded-md text-base py-2 self-start md:self-center hover:scale-110 text-lg' onClick={handleGallery}>Events</button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Modal;
